module.exports = __webpack_public_path__ + "907c2f76057379145d1e71bd33314cfc.png";